import React, { Component } from 'react'
import { Alert } from 'react-bootstrap';
import { Row, Card, Col, Jumbotron, Container, Table, Button } from 'react-bootstrap';
import { CSVLink } from "react-csv";
// ;
import Spinner from '../../subcomponent/spinner';
import funciones from '../../../middleware/funciones';
import config from '../../../config';

export class precios extends Component {
    constructor(props) {
        super(props)
        const currentCompany = sessionStorage.getItem('company');
        this.uploadTxtFile = this.uploadTxtFile.bind(this);
        //this.uploadCsvFile = this.uploadCsvFile.bind(this);
        this.state = {
            csvData: [],
            txtData: [],
            listErrores: [],
            empresa: currentCompany,
            loadingText: false,
            mensajeProcess: "",
            estadoProcess: false,
            tipoAlert: "",
            infobase: [[]],
            controlData: true
        }
    }

    componentDidMount = () => {
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        }

        fetch(config.servBackEnd + '/cargadata/baseinfo', datasend)
            .then(res => res.json())
            .then((data) => {
                const infobase = data.data[0];
                if (data.ok) {
                    this.setState({ infobase });
                } else {
                    this.setState({ controlData: false });
                }
            })
            .catch((error) => console.error(error))
    }

    uploadTxtFile(event) {
        this.setState({ loadingText: true });
        const listErrores = [];
        const fileReader = new FileReader();
        const file = event.target.files[0];

        const callback = (lines) => {
            const cabeceraFile = funciones.limpiezaCaracter(lines[0], ["\r", "\""]);
            const arrayCabeceraFile = cabeceraFile.split(";")
            let infoprecios = [];

            for (let index = 1; index < lines.length - 1; index++) {
                const element = lines[index];
                const data = funciones.limpiezaCaracter(element, ["\r", "\""]);
                const arrayData = data.split(";");
                if (element.length > 0) {
                    infoprecios.push(arrayData.slice(0, arrayCabeceraFile.length));
                } else {
                    const men = "Error en los datos de la fila " + (index + 1);
                    this.setState({
                        mensajeProcess: men,
                        estadoProcess: true,
                        tipoAlert: "danger"
                    });
                }
            }

            if (infoprecios.length > 0) {
                const datasend = {
                    method: 'POST',
                    body: JSON.stringify({
                        infoprecios,
                        arrayCabeceraFile
                    }),
                    headers: {
                        'Content-Type': 'application/json',
                        'empresa': this.state.empresa
                    }
                }

                fetch(config.servBackEnd + '/cargadata/cargaprecios', datasend)
                    .then(res => res.json())
                    .then((data) => {
                        data.forEach(element => {
                            if (!element.ok) {
                                listErrores.push(element);
                            }
                        });
                        const mensaje = (listErrores.length > 0) ? "precios actualizados correctamente con advertencias" : "precios actualizados correctamente";
                        const tipo = (listErrores.length > 0) ? "warning" : "success";
                        this.setState({
                            loadingText: false,
                            mensajeProcess: mensaje,
                            estadoProcess: true,
                            tipoAlert: tipo,
                            listErrores
                        });
                    })
                    .catch((error) => console.error(error))
            } else {
                this.setState({ loadingText: false });
            }
        }


        fileReader.readAsText(file);
        fileReader.onloadend = function () {
            const lines = this.result.split('\n');
            callback(lines);
        }


    }
    render() {
        const { loadingText, estadoProcess, mensajeProcess, tipoAlert, listErrores, infobase, controlData } = this.state;
        return (
            <div>

                <Jumbotron className="Jumbotron">
                    <h2>Carga Masiva precios</h2>
                </Jumbotron>
                <Container >
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Row className="justify-content-md-center" >
                                        <h4>Descargar archivo base</h4>
                                        <Col className="mb-2">
                                            {controlData &&
                                                <CSVLink data={infobase} filename={"carga_precios.csv"} separator={";"}>
                                                    <Button variant="success">Descargar</Button>
                                                </CSVLink>
                                            }
                                            {!controlData &&
                                                <Alert variant="warning">El archivo base no se puede generar si no se tienen listas de precios creadas</Alert>
                                            }
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    {(!loadingText) && <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Row className="justify-content-md-center" >
                                        <h4>Carga archivo de precios</h4>
                                        <Col className="mb-2">
                                            <input type="file" name="myFile" accept=".csv" onChange={this.uploadTxtFile} className="btn btn-primary" />
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>}
                    {estadoProcess && <Row className="justify-content-md-center" ><Alert variant={tipoAlert}>{mensajeProcess}</Alert></Row>}
                    {listErrores.length > 0 && <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>No Linea</th>
                                <th>Mensaje de error</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                listErrores.map((data, i) => {
                                    return (<tr key={i}>
                                        <td>{data.linea}</td>
                                        <td>{data.msg}</td>
                                    </tr>)
                                })
                            }
                        </tbody>
                    </Table>
                    }
                    {(loadingText) && <Row>
                        <Col className="mb-2">
                            <Spinner loading={loadingText} />
                        </Col>
                    </Row>}
                </Container>
            </div>
        )
    }
}

export default precios;



// WEBPACK FOOTER //
// ./src/components/bussines/cargacatalogos/precios.jsx